/**
 * GOV.UK One Login Service Header Bundle
 *
 * The source code for the service header is located in
 * src/packages/govuk-one-login/service-header
 */

// Base dvla-external-frontend components
import { initCrossServiceHeader } from './index';
import { initializeApplication } from '../index';

initCrossServiceHeader(); // initialize one-login js
initializeApplication(); // Initialize base dvla-external-frontend components
